import { render, staticRenderFns } from "./PayPal.vue?vue&type=template&id=50f9ffd4&"
import script from "./PayPal.vue?vue&type=script&lang=ts&"
export * from "./PayPal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports